define('views/base/modal-footer',['require','views/base/view','text!templates/modal-footer.ejs'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        template = require('text!templates/modal-footer.ejs');

    var ModalFooter = View.extend({
        autoRender: true,
        template: template,
        listen: {
            'change:buttons model': 'render'
        }
    });

    return ModalFooter;
});

